import React from 'react';
import _find from 'lodash/find';
import { request } from '../../functions/apiRequestHelper';
import Select from '../../audi-ui-components/Select';
import TextField from '../../audi-ui-components/TextField';
import Button from '../../audi-ui-components/Button';
import Modal from '../../audi-ui-components/Modal';
import NavBar from '../../audi-ui-components/NavBar';
import Spinner from '../../audi-ui-components/Spinner';
import IconArrowLeft from '../../audi-ui-components/icons/ArrowLeftNormal';
import { STATES_OPTIONS } from '../../constants';
import ModelFields from './ModelFields';
import ExtraFields from './ExtraFields';
import Vehicle from './Vehicle';
import ListItem from './ListItem';
import Terms from './Terms';
import Disclaimer from './Disclaimer';
import { gtmPush } from '../../functions/gtm';
import './tradein.scss';

import { connect } from 'react-redux';
import { rbGetMakes, rbGetFamilies, getVehicleByRego, skipRego, getVehicleByModel, thatsMyCar, notMyCar, clearRbData, reset, rbGetYearGroups, selectFamily } from '../../redux/Tradein';
const mapStateToProps = state => {
    return {
        loading: state.tradein.loading,
        rbData: state.tradein.rbData,
        rbList: state.tradein.rbList,
        regoError: state.tradein.regoError,
        carNotFound: state.tradein.carNotFound,
        showEstimate: state.tradein.showEstimate,
        showModelFields: state.tradein.showModelFields,
        showExtraFields: state.tradein.showExtraFields,
        rbMakes: state.tradein.rbMakes,
        rbFamilies: state.tradein.rbFamilies,
        rbYearGroups: state.tradein.rbYearGroups
    }
}
const mapDispatchToProps = dispatch => {
    return {
        rbGetMakes: () => { dispatch(rbGetMakes()); },
        rbGetFamilies: (m) => { dispatch(rbGetFamilies(m)); },
        rbGetYearGroups: (f) => { dispatch(rbGetYearGroups(f)); },
        selectFamily: (f) => { dispatch(selectFamily(f)); },
        getVehicleByRego: (r,s,cb,errCb) => { dispatch(getVehicleByRego(r,s,cb,errCb)); },
        skipRego: () => { dispatch(skipRego()); },
        getVehicleByModel: (m,f,y,cb) => { dispatch(getVehicleByModel(m,f,y,cb)); },
        thatsMyCar: (c,cb) => { dispatch(thatsMyCar(c,cb)); },
        notMyCar: () => { dispatch(notMyCar()); },
        clearRbData: () => { dispatch(clearRbData()); },
        reset: () => { dispatch(reset()); },
    };
};

class TradeinForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            searchIdx: 0,
            showTradeTerms: false,
            errors: {}
        };
    }

    componentDidMount() {
        const {rbMakes, rbGetMakes, values} = this.props;
        if (!rbMakes || rbMakes === null || rbMakes.length === 0) {
            rbGetMakes();
        }
        // check if we need to reset
        if ((!values.tradeRego || !values.tradeState) || (this.props.showModelFields && !values.tradeMakeCode)) {
            this.reset();
        }
        // get lowest allowed year
        var d = new Date();
        this.currentYear = d.getFullYear();
        this.lowestYear = d.getFullYear() - 10;
    }

    handleNextRego = () => {
        const {values, setFieldTouched} = this.props;
        setFieldTouched("tradeState");
        setFieldTouched("tradeRego");
        // validate
        let errors = this.state.errors || {};
        if (!values.tradeRego) { errors.tradeRego = "Please enter your vehicle registration number"; } else { errors.tradeRego = ""; }
        if (!values.tradeState) { errors.tradeState = "Please select your registration state"; } else { errors.tradeState = ""; }
        this.setState({errors: errors});
        if (!values.tradeRego || !values.tradeState) {
            return false;
        }
        // send request
        this.props.getVehicleByRego(values.tradeRego, values.tradeState, ()=>{
          gtmPush("Trade In Calculator", "Search By Registration", undefined, {registeredState: values.tradeState});
        }, ()=>{
          this.setState({searchIdx: 1});
        });
    }

    handleNextModel = () => {
        const {values, setFieldTouched, rbMakes, rbFamilies} = this.props;
        setFieldTouched("tradeMakeCode");
        setFieldTouched("tradeYear");
        // validate
        if (!values.tradeMakeCode || !values.tradeYear) {
            let errors = this.state.errors || {};
            if (!values.tradeMakeCode) { errors.tradeMakeCode = "Please select a make"; }
            if (!values.tradeYear) { errors.tradeYear = "Please select a year"; }
            this.setState({errors: errors});
            return false;
        }
        // send request
        this.props.getVehicleByModel(values.tradeMakeCode, values.tradeFamilyCode, values.tradeYear, ()=>{
          var selectedMake = {};
          var selectedFam = {};
          var famOpts = (values.tradeMakeCode && rbFamilies[values.tradeMakeCode]) ? rbFamilies[values.tradeMakeCode] : [];
          if (values.tradeMakeCode) {
              selectedMake = _find(rbMakes, {value: values.tradeMakeCode});
          }
          if (values.tradeFamilyCode) {
              selectedFam = _find(famOpts, {value: values.tradeFamilyCode});
          }
          gtmPush("Trade In Calculator", "Search By Make And Model", undefined, {make: selectedMake.label, model: selectedFam.label});
        });
    }

    selectCar = (rbc) => {
        const {setFieldValue, rbData} = this.props;
        if (rbc && typeof rbc === "string") {
            // selected from list
            setFieldValue("redbookcode", rbc);
            this.props.thatsMyCar(rbc, (car) => {
                // console.log("car", car);
                if (car.make) { setFieldValue("tradeMake", car.make); }
                if (car.family) { setFieldValue("tradeModel", car.family); }
                if (car.year) { setFieldValue("tradeYear", car.year); }
                gtmPush("Trade In Calculator", "Select Vehicle", undefined, {vehicle: `${car.make} ${car.family} ${car.year}`});
                if (car.tradeinmin) {
                  gtmPush("form", "submitSuccess", "tradein-enquiry", {vehicle: `${car.make} ${car.family} ${car.year}`, estimatedMinValue: car.tradeinmin, estimatedMaxValue: car.tradeinmax});
                }
            });
        } else {
            // confirm single
            this.props.thatsMyCar();
            if (rbData.rbc) { setFieldValue("redbookcode", rbData.rbc); }
            if (rbData.make) { setFieldValue("tradeMake", rbData.make); }
            if (rbData.family) { setFieldValue("tradeModel", rbData.family); }
            if (rbData.year) { setFieldValue("tradeYear", rbData.year); }
            // gtmPush("Trade In Calculator", "Select Vehicle", undefined, {vehicle: `${rbData.make} ${rbData.family} ${rbData.year}`}, true);
            if (rbData.tradeinmin) {
              gtmPush("form", "submitSuccess", "tradein-enquiry", {vehicle: `${rbData.make} ${rbData.family} ${rbData.year}`, estimatedMinValue: rbData.tradeinmin, estimatedMaxValue: rbData.tradeinmax});
            }
        }
    }

    reset = () => {
        this.props.reset();
        this.props.setValues(Object.assign({}, this.props.values, {
            tradeState: "", tradeRego: "", tradeMakeCode: "", tradeMake: "", tradeFamilyCode: "", tradeModel: "", tradeYear: "", redbookcode: ""
        }));
    }

    render() {
        const {
            values, touched, setFieldValue, setFieldTouched,
            rbData, rbList, rbMakes, rbFamilies, rbYearGroups, showModelFields, showExtraFields, showEstimate, theme,
        } = this.props;
        const auiTheme = (theme === "dark" ? "light" : null);
        const {errors} = this.state;

        var famOpts = (values.tradeMakeCode && rbFamilies[values.tradeMakeCode]) ? rbFamilies[values.tradeMakeCode] : [];
        var yearOpts = (values.tradeFamilyCode && rbYearGroups && rbYearGroups[values.tradeFamilyCode]) ? rbYearGroups[values.tradeFamilyCode] : [];
        var selectedMake = null;
        var selectedFam = null;
        if (values.tradeMakeCode) {
            selectedMake = _find(rbMakes, {value: values.tradeMakeCode});
        }
        if (values.tradeFamilyCode) {
            selectedFam = _find(famOpts, {value: values.tradeFamilyCode});
        }

        return (
            <div className="tradein-form position-relative">

                {this.props.loading && <div className="spinner-wrapper"><Spinner isContinuous /></div>}
                
                {!rbData && !rbList && <>
                  <p className="mb-2 aui-font-extended"><b>Enter your vehicle's details</b></p>
                  <p className="mb-5">Find your vehicle by registration or by make & model.</p>
                  <NavBar small 
                    actions={[{text: "Registration"}, {text: "Make & Model"}]} 
                    onActionClick={(i) => { this.setState({searchIdx: i}); }} 
                    activeIndex={this.state.searchIdx} 
                    navType="tab" 
                    theme={auiTheme} />
                  {this.state.searchIdx === 0 && <>
                      <div className="mb-3">
                        <TextField name="tradeRego"
                            value={values["tradeRego"] || ""}
                            label="Vehicle Registration *"
                            onChange={(v) => {
                                setFieldValue("tradeRego", v.toUpperCase().replace(" ", ""));
                            }}
                            isInvalid={!!(errors["tradeRego"] && touched["tradeRego"])}
                            invalidMessage={errors["tradeRego"]}
                            theme={auiTheme}
                        />
                      </div>
                      <div className="mb-3">
                        <Select name="tradeState"
                            value={values["tradeState"] || ""}
                            label="Registered State *"
                            options={STATES_OPTIONS}
                            onChange={(v) => { setFieldValue("tradeState", v); }}
                            isInvalid={!!(errors["tradeState"] && touched["tradeState"])}
                            invalidMessage={errors["tradeState"]}
                            theme={auiTheme}
                        />
                      </div>
                      <div className="mt-4">
                          <Button theme={auiTheme} variant={this.props.alwaysShowForm ? "primary" : "secondary"} isStretched onClick={this.handleNextRego} disabled={!values.tradeState || !values.tradeRego}>Search by registration</Button>
                      </div>
                  </>}
                  {this.state.searchIdx === 1 && <>
                    {this.props.regoError && <p className="aui-color-text-red my-2">
                      We could not find your vehicle. Please try searching by make & model.
                    </p>}
                    <ModelFields
                        values={values}
                        errors={errors}
                        touched={touched}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        rbMakes={rbMakes}
                        rbGetFamilies={this.props.rbGetFamilies}
                        selectFamily={this.props.selectFamily}
                        clearRbData={this.props.clearRbData}
                        famOpts={famOpts}
                        yearOpts={yearOpts}
                        theme={theme}
                    />
                    <div className="mt-4">
                        <Button theme={auiTheme} variant={this.props.alwaysShowForm ? "primary" : "secondary"} isStretched onClick={this.handleNextModel} disabled={!values.tradeYear || !values.tradeMakeCode}>Search by make & model</Button>
                    </div>
                  </>}
                  {this.props.alwaysShowForm && <p className="mt-5 aui-small">All fields marked with * are mandatory.</p>}
                </>}

                {rbData && !showEstimate && <div className="mb-4">
                    <p className="mt-5 mb-3 aui-font-extended"><b>Confirm this is your vehicle</b></p>
                    <div className={(theme=="dark" ?  "aui-color-gray10" : "aui-color-gray95") + " p-3 mb-3"}>
                      <Vehicle rbData={rbData} />
                    </div>
                    <div className="row">
                      <div className="col-12 col-small-6 mb-2">
                        <Button variant="primary" isStretched onClick={this.selectCar} theme={auiTheme}>Yes, this is my vehicle</Button>
                      </div>
                      <div className="col-12 col-small-6 mb-2">
                        <Button variant="secondary" isStretched onClick={this.props.notMyCar} theme={auiTheme}>Not my vehicle</Button>
                      </div>
                    </div>
                </div>}

                {rbList && <div className="mb-4">
                    <p className="mt-5 mb-2 aui-font-extended"><b>Select your vehicle</b></p>
                    <div className="rb-list">
                      {rbList.map((car) => {
                        return (
                            <ListItem car={car} selectedMake={selectedMake} selectedFam={selectedFam} onClick={this.selectCar} key={car.rbc} theme={theme} />
                        );
                      })}
                    </div>
                </div>}

                {showEstimate && rbData && rbData.tradeInMin && <>
                  <p className="aui-font-extended mb-2 mt-5"><b>Trade-in estimation value (AUD)</b></p>
                  <div className={(theme=="dark" ? "aui-color-gray10" : "aui-color-gray95") + " p-3 mb-4"}>
                    <Vehicle rbData={rbData} showEstimate />
                    <Disclaimer />
                    <p><Button label="Terms & conditions" buttonType="text" onClick={() => { this.setState({showTradeTerms: true}); }} theme={auiTheme} /></p>
                  </div>
                </>}

                {showEstimate && rbData && !rbData.tradeInMin && <div className="mb-4 aui-color-text-red">
                    Sorry, we don't have a trade-in value for that vehicle. Your dealer will evaluate your vehicle and supply you with a trade-in value.
                </div>}

                {this.props.carNotFound && <div className="mb-4 aui-color-text-red">
                    Sorry, we don't have a trade-in value for that vehicle. Your dealer will evaluate your vehicle and supply you with a trade-in value.
                </div>}

                {showExtraFields && this.props.hasExtraFields && 
                    <ExtraFields
                        values={values}
                        errors={this.props.errors}
                        touched={touched}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                    />
                }

                {(this.props.errors.tradeKms || this.props.errors.tradeHasFinance) && this.props.submitCount > 0 &&
                    <p className="aui-color-text-red my-2">Please complete the trade-in form</p>
                }

                {(rbData || rbList || showModelFields) && <p className="mt-5">
                    <Button theme={auiTheme} variant="secondary" onClick={this.reset} icon={<IconArrowLeft small style={{marginTop:"-10px"}} />}>Reset trade-in</Button>
                </p>}

                <Modal isActive={this.state.showTradeTerms} modalStyle="layer" closeButton close={() => { this.setState({showTradeTerms: false}); }}>
                    <Terms />
                </Modal>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TradeinForm);
